import React, { FC } from 'react';
import { IApplicationHistoryEntry } from 'core/interface/applicationHistory';
import {
  formatApplicationHistoryEntry,
  sortApplicationHistory
} from 'helpers/applicationHistory';

import './Index.scss';

interface ApplicationHistoryListProps {
  history?: IApplicationHistoryEntry[] | null;
  classPrefix: 'IRCard' | 'ORCard' | 'jCard';
  t: (key: string) => string;
}

const ApplicationHistoryList: FC<ApplicationHistoryListProps> = ({
  history,
  classPrefix,
  t
}) => {
  const historyEntries = sortApplicationHistory(history);

  if (!historyEntries.length) {
    return null;
  }

  return (
    <div className="application-history-list">
      {historyEntries.map((entry) => (
        <div
          className={`${classPrefix}__middle__details__item`}
          key={entry.id}
        >
          <span className={`${classPrefix}__middle__details__item-desc`}>
            {formatApplicationHistoryEntry(entry, t)}
          </span>
        </div>
      ))}
    </div>
  );
};

export default ApplicationHistoryList;
